import {useState, useEffect, useRef} from 'react'

/**
 * Custom hook to track the width of an element and determine if it falls below a specified threshold.
 *
 * This hook is useful for making responsive UI decisions, such as switching between short and long text,
 * adjusting styles, or modifying layout behavior based on an element's width.
 * **/

const useResponsiveWidth = (threshold) => {
    const [isCompact, setIsCompact] = useState(false)
    const elementRef = useRef(null)

    useEffect(() => {
        const checkElementWidth = () => {
            if (elementRef.current) {
                setIsCompact(elementRef.current.clientWidth < threshold)
            }
        }

        checkElementWidth()
        window.addEventListener('resize', checkElementWidth)

        return () => window.removeEventListener('resize', checkElementWidth)
    }, [threshold])

    return {elementRef, isCompact}
}

export default useResponsiveWidth
